import React, { ReactElement } from "react";

export default function FastIcon(): ReactElement {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="72"
            height="72"
            fill="none"
            viewBox="0 0 72 72"
        >
            <path
                fill="#FE895C"
                d="M65.256 32.442c-1.832-.297-3.59 1.04-3.895 2.826-.763 5.277-3.206 10.11-7.101 13.903-5.803 5.652-13.67 7.956-21.23 6.916l-4.43 5.947c2.596.67 5.194.966 7.79.966 8.172 0 16.42-3.049 22.68-9.144 4.964-4.834 8.096-10.931 9.09-17.697.304-1.858-1.072-3.494-2.904-3.717zM64.83 3.786c-1.871 0-3.37 1.515-3.37 3.407v4.846l-2.697-2.725a31.145 31.145 0 00-44.426 0C6.245 17.49 3.545 29.076 6.169 39.6l5.77-8.026c.073-6.36 2.47-12.645 7.19-17.49 9.666-9.767 25.323-9.767 34.913 0l2.697 2.725h-4.796c-1.872 0-3.371 1.515-3.371 3.407 0 1.894 1.5 3.408 3.371 3.408h12.888c1.872 0 3.37-1.514 3.37-3.408V7.193c0-1.892-1.498-3.407-3.371-3.407z"
            ></path>
            <path
                fill="#FE895C"
                d="M35.757 14.4c-1.975 0-3.555 1.477-3.555 3.322V31.6c0 1.476 1.026 2.806 2.608 3.175l10.902 2.878c.317.074.634.148.95.148 1.58 0 3.002-.96 3.398-2.436.552-1.773-.553-3.618-2.45-4.06l-8.298-2.214V17.72c0-1.844-1.577-3.32-3.553-3.32h-.002zM28.27 45.612h-5.908l1.764-12.652c.308-2.17-2.53-3.219-3.834-1.498L3.798 53.697c-.997 1.348 0 3.294 1.686 3.294h5.91L9.63 69.643c-.306 2.17 2.53 3.218 3.834 1.497l16.493-22.31c1.075-1.347.078-3.219-1.687-3.219z"
            ></path>
        </svg>
    );
}
